<template lang="pug">
	include existingPlusAlteration.pug
</template>

<script>
import uploadPopUp from '@/commonSite/uploadFiles'
export default {
	name: 'existing-plus-additions',
	components: {
		uploadPopUp
	},
	data: function () {
		return {
			navLinks: {},
			additionCheck: false,
			dwellingUnits: 0,
			dynamicFields: [],
			dwellingUnitsAlert: false,
			disabled: false,
			placeholder: 'enter AUD',
			allFloorArea: 100,
			status: 'not_accepted',
			NofUnique: '',
			dismissSecs: 8,
			dismissCountDown: 0,
			showDismissibleAlert: false
			// fruits: ['apple', 'banana', 'orange']
		}
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
	},
	created: function () {
		this.watchField()
	},
	methods: {
		isCheck () {
			if (this.additionCheck) {
				this.disabled = true
				this.dwellingUnits = 2
				this.addOrRestElements(this.dwellingUnits)
			} else {
				this.dynamicFields.length = 0
				this.dwellingUnits = 0
				this.disabled = false
			}
		},
		dwellingUnitsCheck (newValue) {
			// this.addOrRestElements(this.dwellingUnits)
			this.addOrRestElements(this.dwellingUnits)
			if (this.dwellingUnits <= 1) {
				this.showAlert()
				this.dwellingUnits = 2
				this.dwellingUnitsAlert = true
				this.placeholder = 'disabled'
			} else {
				this.dwellingUnitsAlert = false
				this.placeholder = 'floor Area'
			}
		},
		watchField () {
			// this.eleFor = this.dwellingUnits
			if (this.dwellingUnits === 0 && this.additionCheck) {
				this.dwellingUnits = 0
			}
		},
		addOrRestElements (valor) {
			this.dynamicFields.length = 0
			let i = 0
			for (i; i <= valor - 1; i++) {
				this.dynamicFields.push(valor - 1)
			}
			// console.log('this.dwellingUnits ' + this.dwellingUnits)
		},
		countDownChanged (dismissCountDown) {
			this.dismissCountDown = dismissCountDown
		},
		showAlert () {
			this.dismissCountDown = this.dismissSecs
		}
	}
}
</script>

<style lang="less" scoped>
@import '~Css/variable';
@import '~Css/responsive';
	.field-disabled, .field-disabled {
		background-color: white !important;
	}
	.dwellingUnitsContainer{
		display: flex;
		flex-direction: column;
		// border: 1px solid green;
		margin-left: 15px;
		margin-bottom: 20px;
	}
	.labelAlteration{
		display: inline;
	}
	.alert-container{
		margin-left: 20px;
		width: 95%;
		.medium-device-and-down({
			margin-left: 2px;
		});
		b-alert{
			height: 50px;
		}
	}
	.adu{
		font-size: .8em;
	}
	.dynamicFields{
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		padding-top: 10px;
		width: 98%;
		z-index: 50;
		div{
			padding: 8px;
			background-color: @blueLight;
			margin: 2px;
			margin-right: 8px;
			margin-bottom: 10px;
		}
	}
	.redBorder{
		border: 2px solid red;
	}
	.bottomBorder{
		border-bottom: 1px solid @easy24-1;
	}
	.dwellingUnits{
		display: inline;
		padding: 2px;
	}
	.field-dwellingUnits{
		display: inline;
	}
	.florAreaResult{
		background-color: white;
	}
</style>



// WEBPACK FOOTER //
// src/components/complianceWizard/residentialWizards/existingPlusAlteration.vue